import Policy, { policies } from "./pages/Policy";
import type { RouteRecord } from "vite-react-ssg";
import { Navigate } from "react-router-dom";
import { catalog } from "@/lib/api";
import { Layout } from "@/components/layout/Layout";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import Product from "./pages/Product";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Payment from "./pages/Payment";
import OrderLookup from "./pages/OrderLookup";
import About from "./pages/About";
import Clients from "./pages/Clients";
import Contact from "./pages/Contact";
import Assembly from "./pages/Assembly";
import PaketHemat from "./pages/PaketHemat";
import Campaign from "./pages/Campaign";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

// Static routes prerender normally. Product discovery uses the API at build
// time when reachable, and at runtime for products authored after deployment.
export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "katalog", element: <Catalog /> },
      { path: "paket-hemat", element: <PaketHemat /> },
      {
        path: "produk/:slug",
        element: <Product />,
        getStaticPaths: async () => {
          try {
            const { products } = await catalog.list();
            return products.map((p) => `/produk/${p.slug}`);
          } catch {
            return [];
          } // Runtime API routes still resolve after deployment.
        },
      },
      { path: "keranjang", element: <Cart /> },
      { path: "checkout", element: <Checkout /> },
      // The branded payment page. The order does not exist until somebody
      // buys something, so one shell is prerendered (its loading state) and
      // the Worker serves it for every /bayar/* (worker/index.ts, shellFor).
      // Deliberately noindex: its URL carries a live order number and the
      // token that opens it.
      { path: "bayar/:orderNumber", element: <Payment />, getStaticPaths: () => ["/bayar/_shell"] },
      { path: "cek-pesanan", element: <OrderLookup /> },
      // Removed at the client's request (7 Oct 2026). Kept as a redirect so a
      // shared or indexed link lands on Tentang, not an error screen.
      { path: "yang-tidak-kami-lakukan", element: <Navigate to="/tentang" replace /> },
      // Campaign pages (DEL-437). They're authored after a deploy, so one
      // shell is prerendered (reduced header, loading state) and the Worker
      // serves it for every /lp/*. Without it the SPA fallback served the
      // home page, whose navbar flashed before the campaign drew.
      { path: "lp/:slug", element: <Campaign />, getStaticPaths: () => ["/lp/_shell"] },
      {
        path: "informasi/:policy",
        element: <Policy />,
        getStaticPaths: () =>
          Object.keys(policies).map((p) => `/informasi/${p}`),
      },
      // The blog (worker/blog.ts). Posts come from Terradium at request time:
      // one shell is prerendered and the Worker renders every post into it,
      // so a post published after the deploy is a full page, not a fallback.
      { path: "blog", element: <Blog /> },
      { path: "blog/:slug", element: <BlogPost />, getStaticPaths: () => ["/blog/_shell"] },
      { path: "perakitan", element: <Assembly /> },
      { path: "kantor", element: <Clients /> },
      { path: "tentang", element: <About /> },
      { path: "kontak", element: <Contact /> },
    ],
  },
];
